import isNil from 'ramda/src/isNil';

export const isEvenNumber = (value: number): boolean => (isNil(value) ? false : value % 2 === 0);
